import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'//引入store
import ElementUI, { Message } from 'element-ui'
import md5 from 'js-md5';
import { get, post } from './request/http'
import { Encrypt, Decrypt,getLocal,setLocal,removeLocal } from './assets/js/utils'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
import 'font-awesome/css/font-awesome.css'
import '././assets/css/theme/index.css'
import './assets/css/icon.css';
import BabelPolyfill from 'babel-polyfill';


ElementUI.Dialog.props.closeOnClickModal.default = false;


ElementUI.Table.props.highlightCurrentRow.default=true;

 

Vue.use(ElementUI,{size:'small'});
Vue.use(BabelPolyfill);
Vue.config.productionTip = false;

Vue.prototype.$md5 = md5;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$Encrypt = Encrypt;
Vue.prototype.$Decrypt = Decrypt;
Vue.prototype.$getLocal = getLocal;
Vue.prototype.$setLocal = setLocal;
Vue.prototype.$removeLocal = removeLocal;


// 防止Message弹出多次
const showMessage = Symbol('showMessage')
class DonMessage {
  success (options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning (options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info (options, single = true) {
    this[showMessage]('info', options, single)
  }
  error (options, single = true) {
    this[showMessage]('error', options, single)
  }
  
  [showMessage] (type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
Vue.prototype.$message = new DonMessage();


/* 路由发生变化编辑页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});





/* eslint-disable no-new */
var vue=new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  

});
export default vue;



// WEBPACK FOOTER //
// ./src/main.js